import React, { useEffect, useState } from 'react';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import FloatingWhatsApp from './components/FloatingWhatsApp';
import HomePage from './pages/HomePage';
import AboutPage from './pages/AboutPage';
import ProductsPage from './pages/ProductsPage';
import ProcessPage from './pages/ProcessPage';
import QualityPage from './pages/QualityPage';
import GlobalPage from './pages/GlobalPage';
import ContactPage from './pages/ContactPage';

const pages = {
  '/': HomePage,
  '/about': AboutPage,
  '/products': ProductsPage,
  '/process': ProcessPage,
  '/quality': QualityPage,
  '/global': GlobalPage,
  '/contact': ContactPage
};

const normalizePath = (path) => {
  if (!path || path === '/index.html') {
    return '/';
  }

  return path.endsWith('/') && path.length > 1 ? path.slice(0, -1) : path;
};

const getCurrentPath = () => {
  const hashPath = window.location.hash.startsWith('#/')
    ? window.location.hash.slice(1)
    : '';

  return normalizePath(hashPath || window.location.pathname);
};

function App() {
  const [currentPath, setCurrentPath] = useState(getCurrentPath);
  const Page = pages[currentPath] || HomePage;

  useEffect(() => {
    const handleRouteChange = () => setCurrentPath(getCurrentPath());
    window.addEventListener('hashchange', handleRouteChange);
    window.addEventListener('popstate', handleRouteChange);
    return () => {
      window.removeEventListener('hashchange', handleRouteChange);
      window.removeEventListener('popstate', handleRouteChange);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [currentPath]);

  return (
    <div className="min-h-screen bg-light text-secondary overflow-x-hidden">
      <Navbar currentPath={currentPath} />
      <Page />
      <Footer />
      <FloatingWhatsApp />
    </div>
  );
}

export default App;
